import {API_BASE_URL} from '../config';
import {get, post, put, del} from './utils';

export const DIVISION_SUCCESS = 'DIVISION_SUCCESS';
export const fetchSuccess = data => ({
    type: DIVISION_SUCCESS,
    data
});

export const DIVISION_ERROR = 'DIVISION_ERROR';
export const fetchError = error => ({
    type: DIVISION_ERROR,
    error
});

export const postDivision = (division) => (dispatch, getState) => {
    return post(dispatch, getState, `${API_BASE_URL}/divisions`, division)
        .then(({division}) => dispatch(fetchSuccess(division)));
};

export const getDivisions = () => (dispatch, getState) => {
    return get(dispatch, getState, `${API_BASE_URL}/divisions`)
        .then(({divisions}) => dispatch(fetchSuccess(divisions)));
};

export const getDivision = (id_division) => (dispatch, getState) => {
    return get(dispatch, getState, `${API_BASE_URL}/divisions/${id_division}`)
        .then(({division}) => dispatch(fetchSuccess(division)));
};

export const putDivision = (division) => (dispatch, getState) => {
    return put(dispatch, getState, `${API_BASE_URL}/divisions/${division.id_division}`, division)
        .then(({division}) => dispatch(fetchSuccess(division)));
};

export const deleteDivision = (id_division) => (dispatch, getState) => {
    return del(dispatch, getState, `${API_BASE_URL}/divisions/${id_division}`)
        .then(({division}) => dispatch(fetchSuccess(division)));
};